import { getClientDoctors } from "./calendar.jsx";

function createArray(...items) {
  return items.filter((i) => i != null);
}

export function getClientProblem(
  client,
  perms = { canSeeRequiresCzechSpeaker: true, canSeeDoctorNecessary: true },
) {
  const prefs = client?.prefs;
  const importantInfoItems =
    client?.importantInfoTags?.map((t) => t.value) ?? [];

  const problems = createArray(
    prefs?.problem,
    prefs?.requires_czech_speaker && perms.canSeeRequiresCzechSpeaker
      ? "Vyžaduje česky mluvící personál."
      : null,
    getClientDoctors(client).length > 0 && perms.canSeeDoctorNecessary
      ? "Vždy nutná přítomnost lékaře."
      : null,
    importantInfoItems.length > 0
      ? "Důležité info: " + importantInfoItems.join(", ")
      : null,
  );

  if (problems.length === 0) {
    return;
  }

  return problems.join("\n");
}
